import {ICRSDetails} from "../interfaces";
import YouTubeInfoIcon from "../../../../ui/svg/common/youtube-info";
import PluginsInfoIcon from "../../../../ui/svg/common/plugins-info";
import ClockIcon from "../../../../ui/svg/common/clock";
import {getJSONFromHtml} from "../../../../domain/common";

const getDuration = (props: ICRSDetails|undefined, crsDetails: ICRSDetails) => {
    if(!props || !crsDetails) return <></>;

    const courseDurationHours = Number(crsDetails.courseDurationHours) || 0;

    return (
        <dt key="courseDurationHours"
            className={"flex flex-row items-center text-sm no-underline " + props?.classNameEx}>
            <ClockIcon width="20" color={crsDetails.colorIcons}/>

            {
                courseDurationHours < 1 &&
                <span
                    className="pl-1 text-sm">
                    { Math.round(courseDurationHours * 60) } { courseDurationHours !== 1 ? 'Minutes' : 'Minute' }
                </span>
            }

            {
                courseDurationHours >= 1 &&
                <span
                    className="pl-1 text-sm">
                    { courseDurationHours } { courseDurationHours !== 1 ? 'Hours' : 'Hour' }
                </span>
            }
        </dt>
    )
};

/**
 * the entry point
 */
const CRSDataDetails = (props?: ICRSDetails) => {
    let crsDetails = props;
    if (!props || Object.keys(props).length === 0) {
        //console.log('CRSDataDetails: getJsonById');
        crsDetails = getJSONFromHtml(document.getElementById('crs-info')) as ICRSDetails;
    }

    //console.log('CRSDataDetails: ',crsDetails);
    if (!crsDetails ||
        (crsDetails.numberOfLessons == null &&
            crsDetails.courseDurationHours == null &&
        crsDetails.numberOfPlugins == null) ||
        (crsDetails.numberOfLessons === 0
            && crsDetails.courseDurationHours === 0
            && crsDetails.numberOfPlugins === 0)){
        return<></>;

    }


    let NumberOfLessons =  <dt key="numberoflessons" className={"flex flex-row items-center text-sm no-underline "  + props?.classNameEx}>
                                <YouTubeInfoIcon width="24"  color={crsDetails.colorIcons} />
                                <span  className="pl-1 text-sm">{crsDetails.numberOfLessons } {crsDetails.numberOfLessons === 1 ? 'Video' : 'Videos' }</span>
                            </dt>

    let CourseDurationHours =   <dt key="courseDurationHours" className={"flex flex-row items-center text-sm no-underline "  + props?.classNameEx}>
                                    <ClockIcon width="20" color={crsDetails.colorIcons} />
                                    <span  className="pl-1 text-sm">{crsDetails.courseDurationHours } {crsDetails?.courseDurationHours && crsDetails?.courseDurationHours > 1 ? "Hours" : "Hour"  }</span>
                                </dt>

    let NumberOfPlugins =    <dt key="numberOfPlugins" className={"flex flex-row items-center text-sm no-underline " + props?.classNameEx} >
                                <PluginsInfoIcon width="22" color={crsDetails.colorIcons} />
                                <span  className="pl-1 text-sm">{crsDetails.numberOfPlugins} Plugins</span>
                            </dt>

    //console.log('crsDetails.designType: ',crsDetails.designType);
    switch (props?.designType)
    {
        case "NumberOfLessons":
            return(NumberOfLessons);

        case "CourseDurationHours":
            return(CourseDurationHours);

        case "NumberOfPlugins":
                return (NumberOfPlugins);

        default:
            return(
                <dl className={"dv-crs-data-details flex flex-row " + props?.classNameEx}>
                    {crsDetails.numberOfLessons !== undefined && crsDetails.numberOfLessons > 0 && <div className="pr-3"> {NumberOfLessons}</div>}
                    {crsDetails.courseDurationHours !== undefined && crsDetails.courseDurationHours > 0 && <div className="pr-3"> { getDuration(props, crsDetails ) }</div>}
                    {crsDetails.numberOfPlugins !== undefined && crsDetails.numberOfPlugins > 0 && <div className="pr-3">{NumberOfPlugins}</div>}
                </dl>
            );
    }
};

export default CRSDataDetails;